import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

export default function PageListItem({
  extraContent,
  handleNavigate,
  Icon,
  index,
  item,
  primaryText,
  secondaryText,
}) {
  return (
    <ListItem
      id={`list-item-${index}`}
      key={index}
      onClick={handleNavigate ? () => handleNavigate(item) : null}
      sx={{
        alignItems: "center",
        bgcolor: "background.paper",
        "&:hover": {
          bgcolor: "background.default",
        },
        borderTop: "1px solid",
        borderColor: "divider",
        cursor: handleNavigate ? "pointer" : null,
        display: "flex",
        justifyContent: "space-between",
        px: "10px",
        py: "13.5px",
      }}
      tabIndex={0}
    >
      <Box id={`list-item-${index}-content`} width="100%">
        <Box display="flex" justifyContent="space-between">
          <Typography noWrap sx={{ width: { xs: "66%", md: "33%" } }}>
            {primaryText}
          </Typography>
          <Typography noWrap align="left" color="text.tertiary" flex={1}>
            {secondaryText}
          </Typography>
        </Box>
        {extraContent ? (
          <Box ml={1} mt={1}>
            {extraContent}
          </Box>
        ) : null}
      </Box>
      {Icon || <KeyboardArrowRightIcon color="secondary" />}
    </ListItem>
  );
}
